import React from "react";
import {
  ReferenceInput,
  SelectInput,
  FormDataConsumer,
  useTranslate,
} from "react-admin";

const EventSelectInput = ({ type = "none", ...props }) => {
  const translate = useTranslate();
  const optionRender = (record) =>
    `${translate(`resources.events.code.${record.name}`)}`;

  return (
    <FormDataConsumer {...props}>
      {({ formData, ...rest }) => (
        <ReferenceInput
          {...props}
          reference="events"
          filter={{
            show_deal: true,
            type: formData.type || type,
            is_money: false,
          }}
          sort={{ field: "name", direction: "DESC" }}
        >
          <SelectInput optionText={optionRender} />
        </ReferenceInput>
      )}
    </FormDataConsumer>
  );
};
export default EventSelectInput;
